<div class="toaster-container">
    @for (toast of toasts; track toast.id) {
    <div class="toast" [class.success]="toast.type === 'success'" [class.error]="toast.type === 'error'"
        [class.warning]="toast.type === 'info'">

        <span class="icon"></span>

        <span class="message">
            {{ toast.message }}
        </span>

        <span class="progress"></span>
    </div>
    }
</div>